var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalaVentas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.068,
    height: 15.414,
    viewBox: "0 0 22.068 15.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #434343;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2993",
    "data-name": "Group 2993",
    transform: "translate(2455.675 13719.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2992",
    "data-name": "Group 2992",
    transform: "translate(-2455.674 -13719.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4247",
    "data-name": "Path 4247",
    className: "cls-1",
    d: "M0,0H22.068V13.986H0ZM5.339,15.413a.588.588,0,0,1,0-1.176H16.728a.588.588,0,0,1,0,1.176ZM.931.932H21.136V13.055H.931V.932Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaVentas);
export default __webpack_public_path__ + "static/media/SalaVentas.7b7c899bc58fa554aa30b597d865e89c.svg";
export { ForwardRef as ReactComponent };